import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import { QuotationSchema } from "../../../Schemas/quotation/quotation_schema";
import { Toast } from "../../../CustomComponent/toast";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcSurvey } from "react-icons/fc";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { toTitleCase } from "../../../Components/Functions/word.fun";
import { roundOffCost } from "../../../Components/Functions/amt.fun";

let infraOptions = [
  {
    name: "cea_nvph_fp_nethouse",
    value: "CEA (NVPH / FP / Nethouse)",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "hydroponic_system",
    value: "Hydroponic System + Ground cover weedmat",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "engineering_errection_commissioning",
    value: "Engineering, Errection & Commissioning",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "ground_cover_weedmat_grade_a_110gsm",
    value: "Ground cover weedmat (Grade A 100GSM)",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "fogger_system_netafim",
    value: "Fogger System",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  // {
  //   name: "crop_support_system_growbags_dutchbucket",
  //   value: "Crop Support System (Only for Growbags & Dutch Bucket)",
  //   checked: false,
  //   isPrimary: false,
  //   unit: "SqM",
  // },
  // {
  //   name: "cyclic_periodic_timers",
  //   value: "Cyclic Periodic Timers",
  //   checked: false,
  //   isPrimary: false,
  // },
  {
    name: "retractable_aluminum_net",
    value: "Retractable Aluminum Net",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "air_circulation_fan_8x4",
    value: "Air circultation 1 Fan per every two 8X4 block",
    checked: false,
    isPrimary: false,
    unit: "Unit",
  },
  {
    name: "electric_panels_fittings",
    value: "Electric Panels + Electric Fittings",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "iot_automation_screen_display",
    value: "IoT Automation & Screen Display",
    checked: false,
    isPrimary: false,
    unit: "Unit",
  },
  {
    name: "mechanical_geared_vent_operator",
    value: "Mechanical Geared Vent Operator",
    checked: false,
    isPrimary: false,
    unit: "",
  },
  {
    name: "drip_system",
    value: "Drip System",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "trellising_installation",
    value: "Trellising Installation",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "bed_preparation",
    value: "Bed Preparation",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  {
    name: "mulching_sheet_installation",
    value: "Mulching Sheet Installation",
    checked: false,
    isPrimary: false,
    unit: "SqM",
  },
  // {
  //   name: "growers_combo_sqm",
  //   value: "Growers Combo (per SqMtr)",
  //   checked: false,
  //   isPrimary: false,
  // },
  // {
  //   name: "additional_handholding_support",
  //   value: "Handholding & Support",
  //   checked: false,
  //   isPrimary: false,
  //   unit: "",
  // },
];

let updatedInfraOptions = infraOptions;

let ceaHydroIndustry = [
  "cea_nvph_fp_nethouse",
  "hydroponic_system",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",

  // "additional_handholding_support",
  // "cyclic_periodic_timers",
];

let ceaHydroKryzenPro = [
  "cea_nvph_fp_nethouse",
  "hydroponic_system",
  "mechanical_geared_vent_operator",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "crop_support_system_growbags_dutchbucket",
  // "cyclic_periodic_timers",
  "retractable_aluminum_net",
  "air_circulation_fan_8x4",
  "electric_panels_fittings",
  // "additional_handholding_support",
];

let ceaHydroKryzenProMax = [
  "cea_nvph_fp_nethouse",
  "hydroponic_system",
  "mechanical_geared_vent_operator",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "crop_support_system_growbags_dutchbucket",
  // "cyclic_periodic_timers",
  "retractable_aluminum_net",
  "air_circulation_fan_8x4",
  "electric_panels_fittings",
  "iot_automation_screen_display",
  // "growers_combo_sqm",
  // "drip_system",
  // "additional_handholding_support",
];

let ceaFanpadHydroIndustry = [
  "cea_nvph_fp_nethouse",
  "hydroponic_system",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "air_circulation_fan_8x4",
  // "additional_handholding_support",
  // "cyclic_periodic_timers",
];

let onlyHydroIndustry = [
  "hydroponic_system",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  // "additional_handholding_support",
  // "cyclic_periodic_timers",
];

let onlyHydroKryzenPro = [
  "hydroponic_system",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "crop_support_system_growbags_dutchbucket",
  // "cyclic_periodic_timers",
  "air_circulation_fan_8x4",
  "electric_panels_fittings",
  // "additional_handholding_support",
];

let onlyHydroKryzenProMax = [
  "hydroponic_system",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "crop_support_system_growbags_dutchbucket",
  // "cyclic_periodic_timers",
  "air_circulation_fan_8x4",
  "electric_panels_fittings",
  "iot_automation_screen_display",
  // "growers_combo_sqm",
  // "drip_system",
  // "additional_handholding_support",
];

let onlyceaIndustry = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  "additional_handholding_support",
];

let onlyceaKryzenPro = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "drip_system",
  // "additional_handholding_support",
];

let onlyceaKryzenProMax = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  // "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "retractable_aluminum_net",
  "drip_system",
  "air_circulation_fan_8x4",
  // "additional_handholding_support",
  // "crop_support_system_growbags_dutchbucket",
];

let onlyFanpadCeaIndustry = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  "additional_handholding_support",
  "air_circulation_fan_8x4",
  "fogger_system_netafim",
];

let onlyFanpadSoilbasedCeaIndustry = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  "additional_handholding_support",
  "air_circulation_fan_8x4",
];

let onlySoilbasedCeaKryzenPro = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  "ground_cover_weedmat_grade_a_110gsm",
  "fogger_system_netafim",
  "drip_system",
  // "additional_handholding_support",
];
let onlySoilbasedCeaKryzenProMax = [
  "cea_nvph_fp_nethouse",
  "engineering_errection_commissioning",
  "fogger_system_netafim",
  "retractable_aluminum_net",
  "drip_system",
  // "trellising_installation",
  // "bed_preparation",
  // "mulching_sheet_installation",
  "air_circulation_fan_8x4",
  // "ground_cover_weedmat_grade_a_110gsm",
  // "additional_handholding_support",
  // "crop_support_system_growbags_dutchbucket",
];
const baySizes = [
  8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84,
  88, 92, 96, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144,
];
const spanSizes = [
  12, 20, 28, 36, 44, 52, 60, 68, 76, 84, 92, 100, 108, 116, 124, 132, 140, 148,
  156, 164, 172, 180, 188, 196, 204, 212, 220, 228, 236, 244, 252, 260, 268,
  276,
];

const EditQuotation = () => {
  const userData = useSelector((store) => store.login.user);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [quot, setQuot] = useState();
  const navigate = useNavigate();
  const [quotationInfo, setQuotationInfo] = useState([]);
  const [manualBaySpan, setManualBaySpan] = useState(false);
  const [quotationCost, setQuotationCost] = useState();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/quotations/getQuotationsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          if (!baySizes?.includes(res?.data?.input_info?.bay_size)) {
            baySizes.push(res?.data?.input_info?.bay_size);
          }
          if (!spanSizes?.includes(res?.data?.input_info?.span_size)) {
            spanSizes.push(res?.data?.input_info?.span_size);
          }
          setQuotationInfo(res.data.input_info);
          setQuot(res.data?.quotationNumber);
          if (res.data.input_info?.infrastructure) {
            updatedInfraOptions = res.data.input_info?.infrastructure;
          }
          setQuotationCost(
            res.data?.quotationMatrixCost?.actualCostWithoutOverride
              ? res.data?.quotationMatrixCost?.actualCostWithoutOverride
              : res.data?.quotationMatrixCost?.asPerIndustryCost
          );
        } else {
          Toast("error", "Error while getting Quotations!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });

    values = {
      ...values,
      maxDiscount: +values.maxDiscount || 0,
      overrideUnitCost: +values.overrideUnitCost,
      contactPersonName: toTitleCase(values.contactPersonName),
      businessName: toTitleCase(values.businessName),
      address: toTitleCase(values.address),
    };

    let totalPercent =
      +values.a_FramePercent +
      +values.flatBedPercent +
      +values.growBagPercent +
      +values.dutchBucketPercent;

    if (totalPercent > 100) {
      Toast("error", "Total Percentage of Frames should be 100%");
    } else if (
      values.quotationType !== "nethouse" &&
      values.quotationType !== "fanpad" &&
      values.quotationType !== "nvph" &&
      values.quotationType !== "soilbasedfanpad" &&
      values.quotationType !== "soilbasednvph" &&
      values.quotationType !== "soilbasednethouse" &&
      totalPercent < 25
    ) {
      Toast("error", "Total Percentage of Frames At Least 25%");
    } else if (values.maxDiscount > 6) {
      Toast("error", "Total discount should be less than 6%");
    } else if (
      values.phoneNumber === "0000000000" ||
      values.phoneNumber === "1111111111" ||
      values.phoneNumber === "2222222222" ||
      values.phoneNumber === "3333333333" ||
      values.phoneNumber === "4444444444" ||
      values.phoneNumber === "5555555555" ||
      values.phoneNumber === "6666666666" ||
      values.phoneNumber === "7777777777" ||
      values.phoneNumber === "8888888888" ||
      values.phoneNumber === "9999999999" ||
      values.phoneNumber === "1234567890" ||
      values.phoneNumber === "9876543210" ||
      values.phoneNumber === "0987654321"
    ) {
      Toast("error", "Invalid phone number");
    } else {
      setLoading(true);
      performRequest(
        "PATCH",
        quot.includes("A/V2")
          ? `/quotations/updateQuotations/${id}`
          : `/quotations/updateQuotationOld/${id}`,
        values
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Quotation updated successfully!");
            navigate(
              quot.includes("A/V2")
                ? `/custom-quotation-v2/${id}`
                : `/custom-quotation/${id}`
            );
          } else {
            Toast("error", "Error while updating");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const updateData = (props, quotationType, value) => {
    if (value === "As Per Industry") {
      if (quotationType === "fanpad") {
        {
          props.setFieldValue("asPerIndustry", onlyFanpadCeaIndustry);
          props.setFieldValue("kryzenPro", onlyceaKryzenPro);
          props.setFieldValue("kryzenProMax", onlyceaKryzenProMax);
          updatedInfraOptions = infraOptions.filter((el) =>
            onlyceaKryzenProMax.includes(el.name)
          );
          updatedInfraOptions = updatedInfraOptions.map((el) => {
            if (onlyFanpadCeaIndustry.includes(el.name)) {
              return {
                ...el,
                isPrimary: true,
                checked: true,
              };
            } else {
              return el;
            }
          });
          props.setFieldValue("infrastructure", updatedInfraOptions);
        }
      } else if (quotationType === "soilbasedfanpad") {
        {
          props.setFieldValue("asPerIndustry", onlyFanpadSoilbasedCeaIndustry);
          props.setFieldValue("kryzenPro", onlySoilbasedCeaKryzenPro);
          props.setFieldValue("kryzenProMax", onlySoilbasedCeaKryzenProMax);
          updatedInfraOptions = infraOptions.filter((el) =>
            onlySoilbasedCeaKryzenProMax.includes(el.name)
          );
          updatedInfraOptions = updatedInfraOptions.map((el) => {
            if (onlyFanpadSoilbasedCeaIndustry.includes(el.name)) {
              return {
                ...el,
                isPrimary: true,
                checked: true,
              };
            } else {
              return el;
            }
          });
          props.setFieldValue("infrastructure", updatedInfraOptions);
        }
      } else if (quotationType === "nvph" || quotationType === "nethouse") {
        props.setFieldValue("asPerIndustry", onlyceaIndustry);
        props.setFieldValue("kryzenPro", onlyceaKryzenPro);
        props.setFieldValue("kryzenProMax", onlyceaKryzenProMax);
        updatedInfraOptions = infraOptions.filter((el) =>
          onlyceaKryzenProMax.includes(el.name)
        );
        updatedInfraOptions = updatedInfraOptions.map((el) => {
          if (onlyceaIndustry.includes(el.name)) {
            return {
              ...el,
              isPrimary: true,
              checked: true,
            };
          } else {
            return el;
          }
        });
        props.setFieldValue("infrastructure", updatedInfraOptions);
      } else if (
        quotationType === "soilbasednvph" ||
        quotationType === "soilbasednethouse"
      ) {
        props.setFieldValue("asPerIndustry", onlyceaIndustry);
        props.setFieldValue("kryzenPro", onlyceaKryzenPro);
        props.setFieldValue("kryzenProMax", onlySoilbasedCeaKryzenProMax);
        updatedInfraOptions = infraOptions.filter((el) =>
          onlySoilbasedCeaKryzenProMax.includes(el.name)
        );
        updatedInfraOptions = updatedInfraOptions.map((el) => {
          if (onlyceaIndustry.includes(el.name)) {
            return {
              ...el,
              isPrimary: true,
              checked: true,
            };
          } else {
            return el;
          }
        });
        props.setFieldValue("infrastructure", updatedInfraOptions);
      } else if (quotationType === "hydroponics only") {
        props.setFieldValue("asPerIndustry", onlyHydroIndustry);
        props.setFieldValue("kryzenPro", onlyHydroKryzenPro);
        props.setFieldValue("kryzenProMax", onlyHydroKryzenProMax);
        updatedInfraOptions = infraOptions.filter((el) =>
          onlyHydroKryzenProMax.includes(el.name)
        );
        updatedInfraOptions = updatedInfraOptions.map((el) => {
          if (onlyHydroIndustry.includes(el.name)) {
            return {
              ...el,
              isPrimary: true,
              checked: true,
            };
          } else {
            return el;
          }
        });
        props.setFieldValue("infrastructure", updatedInfraOptions);
      } else if (quotationType.includes("fanpad with hydroponics")) {
        props.setFieldValue("asPerIndustry", ceaFanpadHydroIndustry);
        props.setFieldValue("kryzenPro", ceaHydroKryzenPro);
        props.setFieldValue("kryzenProMax", ceaHydroKryzenProMax);
        updatedInfraOptions = infraOptions.filter((el) =>
          ceaHydroKryzenProMax.includes(el.name)
        );
        updatedInfraOptions = updatedInfraOptions.map((el) => {
          if (ceaFanpadHydroIndustry.includes(el.name)) {
            return {
              ...el,
              isPrimary: true,
              checked: true,
            };
          } else {
            return el;
          }
        });
        props.setFieldValue("infrastructure", updatedInfraOptions);
      } else if (quotationType.includes("with hydroponics")) {
        props.setFieldValue("asPerIndustry", ceaHydroIndustry);
        props.setFieldValue("kryzenPro", ceaHydroKryzenPro);
        props.setFieldValue("kryzenProMax", ceaHydroKryzenProMax);
        updatedInfraOptions = infraOptions.filter((el) =>
          ceaHydroKryzenProMax.includes(el.name)
        );
        updatedInfraOptions = updatedInfraOptions.map((el) => {
          if (ceaHydroIndustry.includes(el.name)) {
            return {
              ...el,
              isPrimary: true,
              checked: true,
            };
          } else {
            return el;
          }
        });
        props.setFieldValue("infrastructure", updatedInfraOptions);
      }
    }
  };

  const updateArray = (updated, props, name) => {
    let selectedSystem = props.values?.selectedSystem || [];
    let arr = [];
    let arrName = "";
    if (selectedSystem === "Kryzen Pro") {
      arr = props.values.kryzenPro;
      arrName = "kryzenPro";
    } else if (selectedSystem === "Kryzen Pro Max") {
      arr = props.values.kryzenProMax;
      arrName = "kryzenProMax";
    } else if (selectedSystem === "As Per Industry") {
      arr = props.values.asPerIndustry;
      arrName = "asPerIndustry";
    }
    if (updated) {
      arr.push(name);
    } else {
      var index = arr.indexOf(name);
      if (index > -1) {
        arr.splice(index, 1);
      }
    }
    props.setFieldValue(arrName, arr);
  };
  if (quotationInfo?.finalQuotation) {
    Toast("error", "Quotation finalised!, Not available for Edit.");
    navigate(
      quot.includes("A/V2")
        ? `/custom-quotation-v2/${id}`
        : `/custom-quotation/${id}`
    );
  }
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSurvey className="fs-2  me-1" /> Edit quotations
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Edit previously sent quotation.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>SqFt.</th>
                        <th>Bay</th>
                        <th>Span</th>
                        <th>SqM</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1034</td>
                        <td>8</td>
                        <td>12</td>
                        <td>96</td>
                      </tr>
                      <tr>
                        <td>1551</td>
                        <td>12</td>
                        <td>12</td>
                        <td>144</td>
                      </tr>
                      <tr>
                        <td>2067</td>
                        <td>16</td>
                        <td>12</td>
                        <td>192</td>
                      </tr>
                      <tr>
                        <td>2584</td>
                        <td>20</td>
                        <td>12</td>
                        <td>240</td>
                      </tr>
                      <tr>
                        <td>3101</td>
                        <td>24</td>
                        <td>12</td>
                        <td>288</td>
                      </tr>
                      <tr>
                        <td>3617</td>
                        <td>28</td>
                        <td>12</td>
                        <td>336</td>
                      </tr>
                      <tr>
                        <td>4134</td>
                        <td>32</td>
                        <td>12</td>
                        <td>384</td>
                      </tr>
                      <tr>
                        <td>4823</td>
                        <td>16</td>
                        <td>28</td>
                        <td>448</td>
                      </tr>
                      <tr>
                        <td>5167</td>
                        <td>24</td>
                        <td>20</td>
                        <td>480</td>
                      </tr>
                      <tr>
                        <td>6028</td>
                        <td>20</td>
                        <td>28</td>
                        <td>560</td>
                      </tr>
                      <tr>
                        <td>9989</td>
                        <td>116</td>
                        <td>8</td>
                        <td>928</td>
                      </tr>
                      <tr>
                        <td>10851</td>
                        <td>36</td>
                        <td>28</td>
                        <td>1008</td>
                      </tr>
                      <tr>
                        <td>11195</td>
                        <td>52</td>
                        <td>20</td>
                        <td>1040</td>
                      </tr>
                      <tr>
                        <td>12056</td>
                        <td>140</td>
                        <td>8</td>
                        <td>1120</td>
                      </tr>
                      <tr>
                        <td>16878</td>
                        <td>56</td>
                        <td>28</td>
                        <td>1568</td>
                      </tr>
                      <tr>
                        <td>20667</td>
                        <td>32</td>
                        <td>60</td>
                        <td>1920</td>
                      </tr>
                      <tr>
                        <td>26351</td>
                        <td>36</td>
                        <td>68</td>
                        <td>2448</td>
                      </tr>
                      <tr>
                        <td>33584</td>
                        <td>52</td>
                        <td>60</td>
                        <td>3120</td>
                      </tr>
                      <tr>
                        <td>34101</td>
                        <td>88</td>
                        <td>36</td>
                        <td>3168</td>
                      </tr>
                      <tr>
                        <td>42540</td>
                        <td>76</td>
                        <td>52</td>
                        <td>3952</td>
                      </tr>
                      <tr>
                        <td>44951</td>
                        <td>36</td>
                        <td>116</td>
                        <td>1 Acre</td>
                      </tr>
                      <tr>
                        <td>49601</td>
                        <td>128</td>
                        <td>36</td>
                        <td>1 Acre</td>
                      </tr>
                      <tr>
                        <td>54251</td>
                        <td>36</td>
                        <td>140</td>
                        <td> 1.2 Acre</td>
                      </tr>
                      <tr>
                        <td>58729</td>
                        <td>44</td>
                        <td>124</td>
                        <td> 1.3 Acre</td>
                      </tr>
                      <tr>
                        <td>68718</td>
                        <td>76</td>
                        <td>84</td>
                        <td> 1.5 Acre</td>
                      </tr>
                      <tr>
                        <td>90417</td>
                        <td>140</td>
                        <td>60</td>
                        <td>2 Acre</td>
                      </tr>
                      <tr>
                        <td>108500</td>
                        <td>168</td>
                        <td>60</td>
                        <td>2.5 Acre</td>
                      </tr>
                      <tr>
                        <td>108500</td>
                        <td>56</td>
                        <td>180</td>
                        <td>2.5 Acre</td>
                      </tr>
                      <tr>
                        <td>131751</td>
                        <td>204</td>
                        <td>60</td>
                        <td>3 Acre</td>
                      </tr>
                      <tr>
                        <td>132096</td>
                        <td>52</td>
                        <td>236</td>
                        <td>3 Acre</td>
                      </tr>
                      <tr>
                        <td>175668</td>
                        <td>240</td>
                        <td>68</td>
                        <td>4 Acre</td>
                      </tr>
                      <tr>
                        <td>173430</td>
                        <td>76</td>
                        <td>212</td>
                        <td>4 Acre</td>
                      </tr>
                      <tr>
                        <td>217002</td>
                        <td>240</td>
                        <td>84</td>
                        <td>5 Acre</td>
                      </tr>
                      <tr>
                        <td>217002</td>
                        <td>80</td>
                        <td>252</td>
                        <td>5 Acre</td>
                      </tr>
                      <tr>
                        <td>261436</td>
                        <td>264</td>
                        <td>92</td>
                        <td>6 Acre</td>
                      </tr>
                      <tr>
                        <td>261262</td>
                        <td>148</td>
                        <td>164</td>
                        <td>6 Acre</td>
                      </tr>
                      <tr>
                        <td>305698</td>
                        <td>284</td>
                        <td>100</td>
                        <td>7 Acre</td>
                      </tr>
                      <tr>
                        <td>303631</td>
                        <td>164</td>
                        <td>172</td>
                        <td>7 Acre</td>
                      </tr>
                      <tr>
                        <td>347031</td>
                        <td>260</td>
                        <td>124</td>
                        <td>8 Acre</td>
                      </tr>
                      <tr>
                        <td>347204</td>
                        <td>128</td>
                        <td>252</td>
                        <td>8 Acre</td>
                      </tr>
                      <tr>
                        <td>392154</td>
                        <td>276</td>
                        <td>132</td>
                        <td>9 Acre</td>
                      </tr>
                      <tr>
                        <td>347031</td>
                        <td>260</td>
                        <td>140</td>
                        <td>9 Acre</td>
                      </tr>
                      <tr>
                        <td>436588</td>
                        <td>260</td>
                        <td>156</td>
                        <td>10 Acre</td>
                      </tr>
                      <tr>
                        <td>439171</td>
                        <td>200</td>
                        <td>204</td>
                        <td>10 Acre</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={quotationInfo}
                  validationSchema={QuotationSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="row card-body">
                        <div className="py-2">
                          <div className="mb-3 row">
                            <label className="form-label required col-md-3 col-lg-4">
                              Quotation date
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput name="quotationDate" type="date" />
                              {props.touched.quotationDate &&
                                props.errors.quotationDate && (
                                  <p className="text-danger">
                                    {props.errors.quotationDate}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              Currency code
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomSelect type="text" name="currencyCode">
                                <option value="">Select</option>
                                <option value="INR">INR</option>
                              </CustomSelect>
                              {props.touched.currencyCode &&
                                props.errors.currencyCode && (
                                  <p className="text-danger">
                                    {props.errors.currencyCode}
                                  </p>
                                )}
                            </div>
                          </div>
                          {/* <div className="mb-3 row">
                                            <label className="form-label required col-md-3 col-lg-4">
                                              Cost markup percent
                                            </label>
                                            <div className="col-md-9 col-lg-8">
                                              <CustomSelect type="number" name="costMarkupPercent">
                                                <option value="">Select</option>
                                                <option value={0}>0%</option>
                                                <option value={25}>25%</option>
                                                <option value={50}>50%</option>
                                                <option value={75}>75%</option>
                                                <option value={100}>100%</option>
                                              </CustomSelect>
                                              {props.touched.costMarkupPercent &&
                                                props.errors.costMarkupPercent && (
                                                  <p className="text-danger">
                                                    {props.errors.costMarkupPercent}
                                                  </p>
                                                )}
                                            </div>
                                          </div> */}
                          {quot?.includes("A/V2") ? (
                            <>
                              {(userData?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_SALLE_ADMIN) && (
                                <>
                                  <div className="mb-3 row">
                                    <label className="form-label col-md-3 col-lg-4">
                                      Override all cost by percentage
                                      <br />
                                    </label>
                                    <div className="col-md-9 col-lg-8">
                                      <CustomInput
                                        name="overrideCostByPercent"
                                        type="text"
                                        placeholder={
                                          "range of percentage -20 to 20"
                                        }
                                      />
                                      <small className="text-muted d-block mt-1">
                                        <strong>Note:</strong> Enter a negative
                                        value (e.g. <code>-5</code>) to decrease
                                        all costs, or a positive value (e.g.{" "}
                                        <code>5</code>) to increase all costs.
                                      </small>
                                      {props.touched.overrideCostByPercent &&
                                        props.errors.overrideCostByPercent && (
                                          <p className="text-danger">
                                            {props.errors.overrideCostByPercent}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                  {props?.values?.overrideCostByPercent && (
                                    <div className="mb-3 row">
                                      <label className="form-label col-md-3 col-lg-4">
                                        Cost after override
                                      </label>
                                      <div className="col-md-9 col-lg-8">
                                        <p>
                                          PreGst : {roundOffCost(quotationCost)}{" "}
                                          =={" "}
                                          <span className="fw-bold">
                                            Override :{" "}
                                            {roundOffCost(
                                              Number(quotationCost) +
                                                (Number(quotationCost) *
                                                  Number(
                                                    props?.values
                                                      ?.overrideCostByPercent
                                                  )) /
                                                  100
                                            )}
                                          </span>{" "}
                                          == PostGst :{" "}
                                          {roundOffCost(
                                            Number(quotationCost) +
                                              (Number(quotationCost) *
                                                Number(
                                                  props?.values
                                                    ?.overrideCostByPercent
                                                )) /
                                                100 +
                                              (Number(quotationCost) +
                                                (Number(quotationCost) *
                                                  Number(
                                                    props?.values
                                                      ?.overrideCostByPercent
                                                  )) /
                                                  100) *
                                                0.18
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {(userData?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_SALLE_ADMIN) && (
                                <div className="mb-3 row">
                                  <label className="form-label col-md-3 col-lg-4">
                                    Override all cost
                                  </label>
                                  <div className="col-md-9 col-lg-8">
                                    <CustomInput
                                      name="overrideUnitCost"
                                      type="text"
                                    />
                                    {props.touched.overrideUnitCost &&
                                      props.errors.overrideUnitCost && (
                                        <p className="text-danger">
                                          {props.errors.overrideUnitCost}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                          {manualBaySpan ? (
                            <>
                              <div className="mb-3 row">
                                <label className="form-label required col-md-3 col-lg-4">
                                  Bay size
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <CustomInput
                                    type="text"
                                    name="bay_size"
                                  ></CustomInput>
                                  {props.touched.bay_size &&
                                    props.errors.bay_size && (
                                      <p className="text-danger">
                                        {props.errors.bay_size}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="form-label required col-md-3 col-lg-4">
                                  Span size
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <CustomInput
                                    type="text"
                                    name="span_size"
                                  ></CustomInput>
                                  {props.touched.span_size &&
                                    props.errors.span_size && (
                                      <p className="text-danger">
                                        {props.errors.span_size}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="mb-3 row">
                                <label className="form-label required col-md-3 col-lg-4">
                                  Bay size
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <CustomSelect type="number" name="bay_size">
                                    <option value="">Select</option>
                                    {baySizes?.map((number) => (
                                      <option key={number} value={number}>
                                        {number} Mtr
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  {props.touched.bay_size &&
                                    props.errors.bay_size && (
                                      <p className="text-danger">
                                        {props.errors.bay_size}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="form-label required col-md-3 col-lg-4">
                                  Span size
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <CustomSelect type="number" name="span_size">
                                    <option value="">Select</option>
                                    {spanSizes?.map((number) => (
                                      <option key={number} value={number}>
                                        {number} Mtr
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  {props.touched.span_size &&
                                    props.errors.span_size && (
                                      <p className="text-danger">
                                        {props.errors.span_size}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </>
                          )}
                          {props?.values?.bay_size &&
                            props?.values?.span_size && (
                              <div className="mb-3 row">
                                <label className="form-label col-md-3 col-lg-4">
                                  Area
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <p>
                                    {(
                                      props?.values?.bay_size *
                                      props?.values?.span_size *
                                      10.764
                                    ).toFixed(2)}{" "}
                                    SqFt =={" "}
                                    {props?.values?.bay_size *
                                      props?.values?.span_size}{" "}
                                    SqM =={" "}
                                    {(
                                      props?.values?.bay_size *
                                      props?.values?.span_size *
                                      0.009884
                                    ).toFixed(2)}{" "}
                                    Guntha =={" "}
                                    {(
                                      (props?.values?.bay_size *
                                        props?.values?.span_size) /
                                      4046.86
                                    ).toFixed(2)}{" "}
                                    Acre
                                  </p>
                                </div>
                              </div>
                            )}
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              Manual bay and span
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <input
                                style={{ width: `20px`, height: `20px` }}
                                onClick={(e) => {
                                  props.setFieldValue("bay_size", "");
                                  props.setFieldValue("span_size", "");
                                  e.target.checked
                                    ? setManualBaySpan(true)
                                    : setManualBaySpan(false);
                                }}
                                value={manualBaySpan}
                                type="checkbox"
                                width={"20px"}
                                height={"20px"}
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label required col-md-3 col-lg-4">
                              Quotation type
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomSelect
                                type="text"
                                name="quotationType"
                                onChange={(e) => {
                                  props.setFieldValue(
                                    "quotationType",
                                    e.target.value
                                  );
                                  updateData(
                                    props,
                                    e.target.value,
                                    props.values.selectedSystem || ""
                                  );
                                }}
                              >
                                <option value="">Select</option>
                                <option value="fanpad">Only FanPad</option>
                                <option value="nvph">Only NVPH</option>
                                <option value="nethouse">Only NetHouse</option>
                                <option value="fanpad with hydroponics">
                                  FanPad With Hydroponics
                                </option>
                                <option value="nvph with hydroponics">
                                  NVPH With Hydroponics
                                </option>
                                <option value="nethouse with hydroponics">
                                  NetHouse With Hydroponics
                                </option>
                                <option value="hydroponics only">
                                  Hydroponics Only
                                </option>
                                <option value="soilbasedfanpad">
                                  Soilbased FanPad
                                </option>
                                <option value="soilbasednvph">
                                  Soilbased NVPH
                                </option>
                                <option value="soilbasednethouse">
                                  Soilbased NetHouse
                                </option>
                              </CustomSelect>
                              {props.touched.quotationType &&
                                props.errors.quotationType && (
                                  <p className="text-danger">
                                    {props.errors.quotationType}
                                  </p>
                                )}
                            </div>
                          </div>
                          {props.values.quotationType !== "nethouse" &&
                            props.values.quotationType !== "fanpad" &&
                            props.values.quotationType !== "nvph" && (
                              <div>
                                <div className="mb-3 row">
                                  <label className="form-label col-md-3 col-lg-4">
                                    Quote for grow-slab
                                  </label>
                                  <div className="col-md-9 col-lg-8">
                                    <CustomCheckbox
                                      name="isGrowSlab"
                                      type="checkbox"
                                      width={"20px"}
                                      height={"20px"}
                                    />
                                    {props.touched.isGrowSlab &&
                                      props.errors.isGrowSlab && (
                                        <p className="text-danger">
                                          {props.errors.isGrowSlab}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                {(userData.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN_S ||
                                  userData.Role ===
                                    process.env.REACT_APP_ROLE_ADMIN) && (
                                  <div className="mb-3 row">
                                    <label className="form-label col-md-3 col-lg-4">
                                      A-Frame percent
                                    </label>
                                    <div className="col-md-9 col-lg-8">
                                      <CustomSelect
                                        type="number"
                                        name="a_FramePercent"
                                      >
                                        <option value="">Select</option>
                                        <option value={0}>0%</option>
                                        <option value={25}>25%</option>
                                        <option value={50}>50%</option>
                                        <option value={75}>75%</option>
                                        <option value={100}>100%</option>
                                      </CustomSelect>
                                      {props.touched.a_FramePercent &&
                                        props.errors.a_FramePercent && (
                                          <p className="text-danger">
                                            {props.errors.a_FramePercent}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                )}
                                <div className="mb-3 row">
                                  <label className="form-label col-md-3 col-lg-4">
                                    Flat-NFT percent
                                  </label>
                                  <div className="col-md-9 col-lg-8">
                                    <CustomSelect
                                      type="number"
                                      name="flatBedPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.flatBedPercent &&
                                      props.errors.flatBedPercent && (
                                        <p className="text-danger">
                                          {props.errors.flatBedPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="form-label col-md-3 col-lg-4">
                                    {props.values.isGrowSlab
                                      ? "Grow Slab percent"
                                      : "Grow Bag percent"}
                                  </label>
                                  <div className="col-md-9 col-lg-8">
                                    <CustomSelect
                                      type="number"
                                      name="growBagPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.growBagPercent &&
                                      props.errors.growBagPercent && (
                                        <p className="text-danger">
                                          {props.errors.growBagPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="form-label col-md-3 col-lg-4">
                                    Dutch Bucket percent
                                  </label>
                                  <div className="col-md-9 col-lg-8">
                                    <CustomSelect
                                      type="number"
                                      name="dutchBucketPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.dutchBucketPercent &&
                                      props.errors.dutchBucketPercent && (
                                        <p className="text-danger">
                                          {props.errors.dutchBucketPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                            )}
                          {/* <div className="mb-3 row">
                                            <label className="form-label required col-md-3 col-lg-4">
                                              Farm type
                                            </label>
                                            <div className="col-md-9 col-lg-8">
                                              <CustomSelect type="number" name="farmType">
                                                <option value="">Select</option>
                                                <option value="indoor">Indoor</option>
                                                <option value="outdoor">Outdoor</option>
                                              </CustomSelect>
                                              {props.touched.farmType && props.errors.farmType && (
                                                <p className="text-danger">{props.errors.farmType}</p>
                                              )}
                                            </div>
                                          </div> */}
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              Business name
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput name="businessName" type="text" />
                              {props.touched.businessName &&
                                props.errors.businessName && (
                                  <p className="text-danger">
                                    {props.errors.businessName}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label required col-md-3 col-lg-4">
                              Contact person name
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput
                                name="contactPersonName"
                                type="text"
                              />
                              {props.touched.contactPersonName &&
                                props.errors.contactPersonName && (
                                  <p className="text-danger">
                                    {props.errors.contactPersonName}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label required col-md-3 col-lg-4">
                              Phone number
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput name="phoneNumber" type="text" />
                              {props.touched.phoneNumber &&
                                props.errors.phoneNumber && (
                                  <p className="text-danger">
                                    {props.errors.phoneNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              WhatsApp number
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput name="whatsAppNumber" type="text" />
                              {props.touched.whatsAppNumber &&
                                props.errors.whatsAppNumber && (
                                  <p className="text-danger">
                                    {props.errors.whatsAppNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label required col-md-3 col-lg-4">
                              Contact person email
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput
                                type="email"
                                name="contactPersonEmail"
                                min={0}
                                max={35}
                              />
                              {props.touched.contactPersonEmail &&
                                props.errors.contactPersonEmail && (
                                  <p className="text-danger">
                                    {props.errors.contactPersonEmail}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              Gst number
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomInput type="text" name="gstNumber" />

                              {props.touched.gstNumber &&
                                props.errors.gstNumber && (
                                  <p className="text-danger">
                                    {props.errors.gstNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label required col-md-3 col-lg-4">
                              Address
                            </label>

                            <div className="col-md-9 col-lg-8">
                              <CustomInput type="text" name="address" />

                              {props.touched.address &&
                                props.errors.address && (
                                  <p className="text-danger">
                                    {props.errors.address}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              Show project financials
                            </label>
                            <div className="col-md-9 col-lg-8">
                              <CustomCheckbox
                                name="showProjectFinancials"
                                type="checkbox"
                                width={"20px"}
                                height={"20px"}
                              />
                              {props.touched.showProjectFinancials &&
                                props.errors.showProjectFinancials && (
                                  <p className="text-danger">
                                    {props.errors.showProjectFinancials}
                                  </p>
                                )}
                            </div>
                          </div>
                          {/* {(userData?.Role ===
                            process.env.REACT_APP_ROLE_ADMIN_S ||
                            userData?.Role ===
                              process.env.REACT_APP_ROLE_ADMIN) && (
                            <div className="mb-3 row">
                              <label className="form-label col-md-3 col-lg-4">
                                Max discount
                              </label>

                              <div className="col-md-9 col-lg-8">
                                <CustomInput type="text" name="maxDiscount" />

                                {props.touched.maxDiscount &&
                                  props.errors.maxDiscount && (
                                    <p className="text-danger">
                                      {props.errors.maxDiscount}
                                    </p>
                                  )}
                              </div>
                            </div>
                          )} */}
                          {/* {(userData?.Role ===
                                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                                userData?.Role ===
                                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                                <>
                                                  <div className="mb-3 row">
                                                    <label className="form-label col-md-3 col-lg-4">
                                                      New add-on particular
                                                    </label>
                                                    <div className="col-md-9 col-lg-8">
                                                      <CustomInput
                                                        type="text"
                                                        name="addOnParticulars"
                                                      />
                      
                                                      {props.touched.addOnParticulars &&
                                                        props.errors.addOnParticulars && (
                                                          <p className="text-danger">
                                                            {props.errors.addOnParticulars}
                                                          </p>
                                                        )}
                                                    </div>
                                                  </div>
                                                  <div className="mb-3 row">
                                                    <label className="form-label col-md-3 col-lg-4">
                                                      Add-on particular price
                                                    </label>
                                                    <div className="col-md-9 col-lg-8">
                                                      <CustomInput
                                                        type="text"
                                                        name="addOnParticularsPrice"
                                                      />
                      
                                                      {props.touched.addOnParticularsPrice &&
                                                        props.errors.addOnParticularsPrice && (
                                                          <p className="text-danger">
                                                            {props.errors.addOnParticularsPrice}
                                                          </p>
                                                        )}
                                                    </div>
                                                  </div>
                                                </>
                                              )} */}
                          {(userData?.Role ===
                            process.env.REACT_APP_ROLE_ADMIN_S ||
                            userData?.Role ===
                              process.env.REACT_APP_ROLE_ADMIN) && (
                            <>
                              <div className="mb-3 row">
                                <label className="form-label col-md-3 col-lg-4">
                                  Final quotation
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <CustomCheckbox
                                    name="finalQuotation"
                                    type="checkbox"
                                    width={"20px"}
                                    height={"20px"}
                                  />
                                  {props.touched.finalQuotation &&
                                    props.errors.finalQuotation && (
                                      <p className="text-danger">
                                        {props.errors.finalQuotation}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="form-label col-md-3 col-lg-4">
                                  <span>Terms and conditions</span>
                                  <br />
                                  <span>(Additional)</span>
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <CustomTextArea
                                    rows={4}
                                    type="text"
                                    name="termsAndConditions"
                                  />
                                  <p className="text-info">
                                    You can add additional Terms & Conditions
                                    here.
                                    <br />
                                    To add multiple Terms & Conditions, please
                                    enter each one on a new line by pressing the
                                    Enter key.
                                  </p>

                                  {props.touched.termsAndConditions &&
                                    props.errors.termsAndConditions && (
                                      <p className="text-danger">
                                        {props.errors.termsAndConditions}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </>
                          )}
                          <div className="mb-3 row">
                            <label className="form-label col-md-3 col-lg-4">
                              Notes
                            </label>

                            <div className="col-md-9 col-lg-8">
                              <CustomInput type="text" name="notes" />
                              {props.touched.notes && props.errors.notes && (
                                <p className="text-danger">
                                  {props.errors.notes}
                                </p>
                              )}
                            </div>
                          </div>
                          {props.values.quotationType && (
                            <>
                              {/* <div className="mb-3 row">
                                <label className="form-label col-md-3 col-lg-4">
                                  Selected system
                                </label>
                                <div className="col-md-9 col-lg-8">
                                  <div className="d-flex gap-3">
                                    <CustomRadioButton
                                      type="radio"
                                      name="selectedSystem"
                                      value="As Per Industry"
                                      onChange={(e) => {
                                        props.setFieldValue(
                                          "selectedSystem",
                                          "As Per Industry"
                                        );
                                        updateData(
                                          props,
                                          props.values.quotationType,
                                          "As Per Industry"
                                        );
                                      }}
                                    />
                                    <label>As Per Industry</label>
                                    <CustomRadioButton
                                      type="radio"
                                      name="selectedSystem"
                                      value="Kryzen Pro"
                                      onChange={(e) => {
                                        props.setFieldValue(
                                          "selectedSystem",
                                          "Kryzen Pro"
                                        );
                                        updateData(
                                          props,
                                          props.values.quotationType,
                                          "Kryzen Pro"
                                        );
                                      }}
                                    />
                                    <label>Kryzen Pro</label>
                                    <CustomRadioButton
                                      type="radio"
                                      name="selectedSystem"
                                      value="Kryzen Pro Max"
                                      onChange={(e) => {
                                        props.setFieldValue(
                                          "selectedSystem",
                                          "Kryzen Pro Max"
                                        );
                                        updateData(
                                          props,
                                          props.values.quotationType,
                                          "Kryzen Pro Max"
                                        );
                                      }}
                                    />
                                    <label>Kryzen Pro Max</label>
                                    <CustomRadioButton
                                      type="radio"
                                      name="selectedSystem"
                                      value=""
                                      onChange={(e) => {
                                        props.setFieldValue(
                                          "selectedSystem",
                                          ""
                                        );
                                        updateData(
                                          props,
                                          props.values.quotationType,
                                          ""
                                        );
                                      }}
                                    />
                                    <label>Not Desided</label>
                                  </div>
                                  {props.touched.selectedSystem &&
                                    props.errors.selectedSystem && (
                                      <p className="text-danger">
                                        {props.errors.selectedSystem}
                                      </p>
                                    )}
                                </div>
                              </div> */}
                              {quot?.includes("A/V2") && (
                                <div className="mb-3 row">
                                  <label className="form-label col-md-3 col-lg-4">
                                    Infrastructure (Additional topups)
                                  </label>
                                  <div className="col-md-9 col-lg-8">
                                    {updatedInfraOptions.map((item, idx) => (
                                      <div key={idx} className="mb-2">
                                        <div className="d-flex align-items-center">
                                          <input
                                            type="checkbox"
                                            name="infrastructure"
                                            value={item.value}
                                            checked={props.values.infrastructure?.some(
                                              (obj) =>
                                                obj.name === item.name &&
                                                obj.checked
                                            )}
                                            disabled={item.isPrimary}
                                            onChange={(e) => {
                                              const { checked } = e.target;
                                              updateArray(
                                                checked,
                                                props,
                                                item.name
                                              );
                                              let newValues = [
                                                ...props.values.infrastructure,
                                              ];

                                              // Find the object
                                              const objIndex =
                                                newValues.findIndex(
                                                  (obj) =>
                                                    obj.name === item.name
                                                );

                                              if (objIndex > -1) {
                                                newValues[objIndex] = {
                                                  ...newValues[objIndex],
                                                  checked: checked,
                                                };
                                              } else {
                                                // If not in array, add it
                                                newValues.push({
                                                  ...item,
                                                  checked: checked,
                                                });
                                              }

                                              props.setFieldValue(
                                                "infrastructure",
                                                newValues
                                              );
                                            }}
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              marginRight: "8px",
                                            }}
                                          />
                                          <span className="form-check-label">
                                            {item.value}
                                          </span>
                                        </div>
                                      </div>
                                    ))}

                                    {props.touched.infrastructure &&
                                      props.errors.infrastructure && (
                                        <p className="text-danger">
                                          {props.errors.infrastructure}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              )}
                            </>
                          )}{" "}
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Save Quotation" />

                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default EditQuotation;
